"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALIDATE_STATUS_SUCCESS = exports.VALIDATE_STATUS_ERROR = exports.SCROLL_SPACE = exports.MAX_HEIGHT = exports.HoverSource = exports.HIGHTLIGHT_COLOR = void 0;
var MAX_HEIGHT = 112;
exports.MAX_HEIGHT = MAX_HEIGHT;
var SCROLL_SPACE = 40;
exports.SCROLL_SPACE = SCROLL_SPACE;
var VALIDATE_STATUS_SUCCESS = 'success';
exports.VALIDATE_STATUS_SUCCESS = VALIDATE_STATUS_SUCCESS;
var VALIDATE_STATUS_ERROR = 'error';
exports.VALIDATE_STATUS_ERROR = VALIDATE_STATUS_ERROR;
var HIGHTLIGHT_COLOR = 'rgba(75, 79, 166, 0.2)';
exports.HIGHTLIGHT_COLOR = HIGHTLIGHT_COLOR;
var HoverSource = {
  MouseOver: 'MouseOver',
  KeyBoard: 'KeyBoard'
};
exports.HoverSource = HoverSource;